import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyEvent({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M174.9 147.5c-43.2 2.41-60.36 17.5-100.9 15.93-47.85-1.86-78.23-20.72-69.66-62.12C12.37 62.58 70 37 108 19c119.31-56.52 185.35 121.9 66.9 128.5z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        d="M174.9 147.5c-38.25 1.52-55.1 16.03-98.21 16.03-26.57 0-85.29-8.93-71.83-63.98C47.43 142 239.12 59.1 237.26 93.7c-1.94 36.14-31.43 52.58-62.36 53.8z"
        fill="#8F9DD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74 45.9a4 4 0 00-4 4v75.23c0 .74.25 1.44.68 1.96.44.52 1.04.81 1.66.81h96.12c1.3 0 2.34-1.24 2.34-2.77V49.9a4 4 0 00-4-4H74z"
        fill="#fff"
        filter="url(#pic-empty-event_svg__a)"
      />
      <rect opacity={0.1} x={82} y={97} width={20} height={18} rx={1.31} fill="#444053" />
      <rect opacity={0.1} x={110} y={97} width={20} height={18} rx={1.31} fill="#444053" />
      <rect opacity={0.1} x={110} y={71} width={20} height={18} rx={1.31} fill="#444053" />
      <rect opacity={0.1} x={138} y={97} width={20} height={18} rx={1.31} fill="#444053" />
      <rect opacity={0.1} x={138} y={71} width={20} height={18} rx={1.31} fill="#444053" />
      <path
        d="M90.88 68.22a1 1 0 011.85 0l2.54 6.12a1 1 0 00.84.61l6.61.53a1 1 0 01.57 1.76l-5.03 4.3a1 1 0 00-.32 1L99.47 89a1 1 0 01-1.49 1.08l-5.66-3.45a1 1 0 00-1.04 0l-5.65 3.45a1 1 0 01-1.5-1.08l1.54-6.45a1 1 0 00-.32-1l-5.04-4.3a1 1 0 01.57-1.76l6.61-.53a1 1 0 00.84-.61l2.55-6.12z"
        fill="#FECE00"
      />
      <path fill="#fff" d="M83.5 46h70.2v9H83.5z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70 48.18V59.5h100.8V48.18a2.1 2.1 0 00-.68-1.54 2.43 2.43 0 00-1.66-.64H72.34c-.62 0-1.22.23-1.66.64-.43.4-.68.96-.68 1.54zm25.2 5.92a1.8 1.8 0 110-3.6 1.8 1.8 0 010 3.6zm50.4 0a1.8 1.8 0 111.27-.53c-.34.34-.8.53-1.27.53z"
        fill="#717074"
      />
      <path
        d="M157 126.36a1.8 1.8 0 00-2.96-1.38l-2.4 2.01c-.4.34-.64.85-.64 1.38v31.13a1 1 0 001 1h4a1 1 0 001-1v-33.14z"
        fill="#666"
      />
      <path
        d="M128.68 139.82c.93.93 2.43.93 3.36 0l2.96-2.96-3.36-3.36-2.96 2.96a2.37 2.37 0 000 3.36z"
        fill="#6C7EC9"
      />
      <path
        d="M136.87 139.34l15.24-12.8 17.79-14.97-12.61-12.51L129.52 132l7.34 7.34z"
        fill="#7E90DC"
      />
      <path
        opacity={0.8}
        d="M153.3 115.7l4.94-4.95"
        stroke="#6C7EC9"
        strokeWidth={2.5}
        strokeLinecap="round"
      />
      <path
        d="M170.2 85c-3.66 0-7.05 1.41-9.69 4.05a13.59 13.59 0 00-3.9 8.44c-.06.8.27 1.57.84 2.13l11.88 11.8c.56.56 1.32.89 2.11.82a13.79 13.79 0 008.46-3.9 13.74 13.74 0 000-19.3 13.52 13.52 0 00-9.7-4.04z"
        fill="#6C7EC9"
      />
      <g opacity={0.7} fill="#8F9DD6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160 71.15a1.14 1.14 0 01.22 2.27c-3.59.27-6.85 1.7-9.53 4.12a15.78 15.78 0 00-5.09 8.96 1.19 1.19 0 01-1.34.9.9.9 0 01-.61-.33 1.06 1.06 0 01-.3-.94 18.13 18.13 0 015.8-10.3A18.26 18.26 0 01160 71.14zm-4.56 11.67a10.37 10.37 0 00-3.03 4.96c-.2.57-.8.96-1.3.76a1 1 0 01-.53-.32 1.14 1.14 0 01-.23-1.06 12.37 12.37 0 0110.04-9.04c.58-.05 1.15.32 1.24.95.06.6-.3 1.16-.94 1.25a10.22 10.22 0 00-5.25 2.5z"
        />
        <path d="M161.25 72.18l-.5.04.08.9.72-.55-.3-.4zM160 71.15l-.03-.5.03.5zm1.25 1.03l.5-.04-.07-.92-.74.56.3.4zm-1.03 1.24l.03.5h.01l-.04-.5zM145.6 86.5l.49.12v-.03l-.49-.09zm-1.34.9l.1-.5h-.07l-.03.5zm-.9-1.27l-.5-.09.5.1zm9.05 1.65l.47.16v-.02l.01-.01-.48-.13zm-1.3.76l.19-.46-.03-.01-.03-.01-.13.48zm-.76-1.38l-.49-.13.49.13zm10.03-9.04l-.04-.5h-.02l-.02.01.08.5zm1.25.95l.5-.04V79l-.5.07zm-.94 1.25l-.07-.5h-.01l.08.5zm1.06-8.19a1.65 1.65 0 00-1.78-1.48l.07 1c.4-.03.68.25.7.57l1-.09zm-.8-.35l.6.8-.6-.8zm-.69 2.14a1.65 1.65 0 001.49-1.78l-1 .07c.03.4-.25.69-.58.71l.09 1zm-9.24 3.99a15.38 15.38 0 019.23-3.99l-.07-1c-3.7.28-7.06 1.75-9.83 4.25l.67.74zm-4.92 8.68c.57-3.3 2.31-6.33 4.92-8.68l-.67-.74a16.28 16.28 0 00-5.24 9.24l.99.18zm-1.94 1.3a1.7 1.7 0 001.93-1.27l-.97-.24c-.1.38-.46.59-.77.52l-.19.99zm-.89-.49c.21.24.53.47.96.5l.06-1c-.08 0-.17-.05-.27-.17l-.75.67zm-.4-1.35c-.1.54.08.99.4 1.35l.75-.67a.57.57 0 01-.17-.52l-.98-.16zm5.94-10.6a18.62 18.62 0 00-5.94 10.6l.98.17c.7-3.88 2.67-7.36 5.63-10.03l-.67-.74zm11.15-4.8c-4.2.34-8.03 2-11.15 4.8l.67.74a17.76 17.76 0 0110.56-4.55l-.08-1zM152.9 87.9a9.89 9.89 0 012.88-4.72l-.67-.75a10.89 10.89 0 00-3.17 5.2l.96.27zm-1.96 1.1c.42.17.86.07 1.2-.13.34-.2.62-.54.75-.94l-.94-.33a.79.79 0 01-.33.41c-.14.09-.25.09-.31.06l-.37.93zm-.72-.45c.23.25.48.4.78.47l.25-.97a.51.51 0 01-.28-.17l-.75.67zm-.35-1.52c-.15.57 0 1.13.35 1.52l.75-.67a.64.64 0 01-.13-.6l-.97-.25zm3.82-6.27a13.01 13.01 0 00-3.82 6.26l.97.26a12 12 0 013.52-5.77l-.67-.74zm6.62-3.14c-2.46.4-4.74 1.45-6.62 3.15l.67.74a11.87 11.87 0 016.11-2.9l-.16-.99zm1.83 1.37a1.63 1.63 0 00-1.8-1.37l.1 1c.37-.04.66.18.71.51l.99-.14zm-1.37 1.82a1.63 1.63 0 001.37-1.8l-1 .1c.04.36-.18.66-.51.7l.14 1zm-4.99 2.37a9.72 9.72 0 015-2.37l-.16-1a10.81 10.81 0 00-5.5 2.62l.66.75z" />
      </g>
      <g opacity={0.7} fill="#8F9DD6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M181.81 124.17a1.15 1.15 0 01-1.3-.96c-.08-.67.38-1.22.97-1.3a15.89 15.89 0 009.3-4.61 15.78 15.78 0 004.6-9.22c.13-.63.72-1.05 1.3-.96a.9.9 0 01.63.3c.25.25.38.54.34.91a18.1 18.1 0 01-5.24 10.6 18.26 18.26 0 01-10.6 5.24zm3.95-11.9a10.37 10.37 0 002.76-5.1c.17-.6.76-1.01 1.26-.84a1 1 0 01.54.3c.25.25.38.62.3 1.04a12.36 12.36 0 01-9.55 9.55c-.6.08-1.18-.25-1.3-.88-.09-.59.25-1.17.88-1.3a10.22 10.22 0 005.1-2.76z"
        />
        <path d="M180.51 123.2l.5-.06-.13-.9-.69.58.32.39zm1.3.97l.06.5-.06-.5zm-1.3-.96l-.5.06.12.91.7-.6-.32-.37zm.97-1.3l-.07-.5.07.5zm13.9-13.83l-.48-.1v.02l-.01.02.5.06zm1.3-.96l-.07.5h.07v-.5zm.97 1.21l.5.07v-.01l-.5-.06zm-9.13-1.16l-.48-.14v.03l.48.1zm1.26-.84l-.16.47.03.01.03.01.1-.49zm.84 1.34l.48.1-.48-.1zm-9.56 9.55l.07.5h.02l.02-.01-.1-.49zm-1.3-.88l-.49.07v.03l.5-.1zm.89-1.3l.1.5v-.01l-.1-.49zm-.63 8.24c.12.85.9 1.5 1.85 1.39l-.12-1a.65.65 0 01-.74-.53l-1 .14zm.82.3l-.65-.76.65.77zm.57-2.17c-.85.12-1.51.91-1.4 1.86l1-.13a.65.65 0 01.54-.74l-.14-.99zm9.02-4.46a15.39 15.39 0 01-9.02 4.46l.13 1a16.38 16.38 0 009.6-4.76l-.71-.7zm4.46-8.93a15.28 15.28 0 01-4.46 8.93l.7.7a16.27 16.27 0 004.75-9.5l-1-.13zm1.86-1.4a1.69 1.69 0 00-1.85 1.36l.98.2a.69.69 0 01.73-.57l.14-.99zm.91.44a1.4 1.4 0 00-.97-.44l-.01 1c.07 0 .17.03.28.15l.7-.71zm.48 1.33c.07-.55-.13-.99-.47-1.33l-.71.7c.16.16.21.31.19.52l1 .11zm-5.38 10.9a18.63 18.63 0 005.38-10.9l-.99-.12c-.49 3.9-2.28 7.5-5.1 10.3l.71.72zm-10.88 5.38a18.75 18.75 0 0010.88-5.38l-.7-.71a17.75 17.75 0 01-10.31 5.1l.13.98zm6.15-17.61a9.88 9.88 0 01-2.63 4.86l.71.71a10.88 10.88 0 002.9-5.36l-.98-.21zm1.9-1.2a1.35 1.35 0 00-1.19.19 1.8 1.8 0 00-.7.98l.96.27a.8.8 0 01.3-.42c.14-.1.25-.1.32-.08l.32-.94zm.75.4a1.5 1.5 0 00-.8-.42l-.2.98c.11.02.2.06.29.16l.7-.71zm.43 1.5a1.63 1.63 0 00-.44-1.5l-.7.72c.13.13.2.33.16.59l.98.2zm-3.5 6.46a13.02 13.02 0 003.5-6.44l-.98-.22a12.01 12.01 0 01-3.22 5.96l.7.7zm-6.44 3.49c2.44-.52 4.66-1.7 6.45-3.49l-.7-.7a11.87 11.87 0 01-5.96 3.21l.21.98zm-1.9-1.27c.19.93 1.06 1.4 1.86 1.28l-.13-1c-.37.06-.68-.15-.74-.48l-.98.2zm1.28-1.89a1.63 1.63 0 00-1.28 1.86l1-.14c-.06-.37.14-.67.47-.74l-.2-.98zm4.85-2.63a9.72 9.72 0 01-4.86 2.63l.21.98c2.02-.44 3.87-1.4 5.36-2.9l-.7-.7z" />
      </g>
      <defs>
        <filter
          id="pic-empty-event_svg__a"
          x={66}
          y={43.9}
          width={108.8}
          height={90}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3022_2335" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_3022_2335" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyEvent.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyEvent.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicEmptyEvent svgRef={ref} {...props} />);
export default ForwardRef;
